import { useTranslation } from 'react-i18next';
import { useContext, useEffect, useState } from 'react';
import styles from './RepresentativePage.module.css';
import CustomerSectionWrapper
  from '../../components/layout/CustomerSectionWrapper/CustomerSectionWrapper';
import RepresentativeSearch
  from '../../components/customer/RepresentativeSearch/RepresentativeSearch';
import RepresentativeSearchResultTable
  from '../../components/customer/Search/RepresentativeSearchResultTable';
import Customer from '../../models/Customer';
import RepresentativeView from '../../components/customer/Representative/RepresentativeView';
import RepresentativeRegister
  from '../../components/customer/Representative/RepresentativeRegister';
import SearchContext from '../../context/search-context';
import CustomerContext from '../../context/customer-context';
import Error from '../../components/common/Error/Error';
import Button from '../../components/common/Button/Button';

function RepresentativePage() {
  const { t } = useTranslation();
  const customerCtx = useContext(CustomerContext);
  const [representatives, setRepresentatives] = useState<Customer[]>([]);
  const [isAddNew, setIsAddNew] = useState<boolean>();
  const searchCtx = useContext(SearchContext);

  useEffect(() => {
    setRepresentatives([]);
    setIsAddNew(false);
  }, [searchCtx.searchResult]);

  const onSelectButtonHandler = (customers: Customer[]) => {
    setRepresentatives(customers);
  };

  const cancelRepresentativeViewHandle = (representative: Customer) => {
    setRepresentatives(prevState => prevState.filter(
      person => person.id !== representative.id,
    ));
  };

  const cancelRepresentativeRegisterHandle = () => {
    setIsAddNew(false);
  };

  const buttonClickHandler = () => {
    setIsAddNew(true);
  };

  return (
    <>
      {customerCtx.customer.id && (
        <div className={styles.backdrop}>
          <CustomerSectionWrapper
            title={t('representative.title')}
          >
            <div className={styles.container}>
              <RepresentativeSearch customer={customerCtx.customer} />
              <div>
                <Button
                  handleClick={buttonClickHandler}
                  text={t('dashboard.newClient')}
                  margin='0 0 0 20px'
                />
              </div>
            </div>
            {!isAddNew && searchCtx.searchResult.length !== 0 && representatives.length === 0 &&
              <RepresentativeSearchResultTable
                onSelect={onSelectButtonHandler}
              />}
            {!isAddNew && searchCtx.searchResult.length === 0 && representatives.length === 0 && (
              <p className={styles.notFound}>{t('header.search.clientNotFound')}</p>
            )}
          </CustomerSectionWrapper>
            {!isAddNew && representatives.length > 0 && (
              <CustomerSectionWrapper
                title={t('representative.view.title')}
              >
                {representatives.map(representative =>
                  <div key={representative.id}>
                    <RepresentativeView
                      customer={customerCtx.customer}
                      representative={representative}
                      cancelRepresentative={cancelRepresentativeViewHandle}
                    />
                  </div>,
                )}
              </CustomerSectionWrapper>
            )}
            {isAddNew && (
              <CustomerSectionWrapper
                title={t('representative.view.title')}
              >
                <RepresentativeRegister
                  onCancel={cancelRepresentativeRegisterHandle}
                  customer={customerCtx.customer}
                />
              </CustomerSectionWrapper>
            )}
        </div>
      )}
      {!customerCtx.customer.id && (
        <div className={styles.errorContainer}>
          <Error messageText={t('representative.customerNotFound')} />
        </div>
      )}
    </>
  );
}

export default RepresentativePage;
